export default __webpack_public_path__ + "e3f36081c4a18627cb10d42b0b0943c3.png";